/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roomannouncementhint2Inputs */

const en_roomannouncementhint2 = /** @type {(inputs: Roomannouncementhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goes out as a notification to everyone checked in right now.`)
};

const de_roomannouncementhint2 = /** @type {(inputs: Roomannouncementhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geht als Mitteilung an alle, die gerade eingecheckt sind.`)
};

/**
* | output |
* | --- |
* | "Goes out as a notification to everyone checked in right now." |
*
* @param {Roomannouncementhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementhint2 = /** @type {((inputs?: Roomannouncementhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementhint2(inputs)
	return de_roomannouncementhint2(inputs)
});
export { roomannouncementhint2 as "roomAnnouncementHint" }